module.exports = __webpack_public_path__ + "static/media/1017751.384bb796.png";